import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { CustomSelectDropdown } from "./custom.select";
import { selectStyle } from "../../../shared/fixtures/select_style";
import { getCities } from "../../../shared/helpers/util.country";
import { P } from "../Texts";

export const CitySelect = (props) => {
  const formCtx = useFormContext();
  const {
    watch,
    formState: { errors: formStateErrors },
  } = formCtx;

  const [cities, setCities] = useState([]);
  const { _state } = props;

  const state_value = watch(_state);

  const getSpecificStates = async () => {
    const states = await getCities({ state: state_value.label });
    setCities(states);
  };

  useEffect(() => {
    if (state_value?.label) {
      getSpecificStates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state_value]);
  return (
    <div className="mb-4">
      <label htmlFor={props.name}>
        <P fontSize="14px" fontFamily="semi" color="#47495C" className="mb-2">
          City
        </P>
      </label>
      <Controller
        control={props.control}
        {...props}
        defaultValue=""
        render={({ field }) => (
          <CustomSelectDropdown
            autoComplete="true"
            styles={selectStyle}
            {...field}
            className="w-full"
            placeholder="--Select a city--"
            options={cities}
            isLoading={cities?.length === 0}
            isDisabled={cities?.length === 0}
          />
        )}
      />

      {formStateErrors[props.name] && (
        <P fontSize="12px" className="mt-2 mb-4 text-red-400 text-sm">
          Select a city
        </P>
      )}
    </div>
  );
};
